import React from 'react';
import PropTypes from 'prop-types';
import FaFileO from 'react-icons/lib/fa/file-o';
import FaFileImageO from 'react-icons/lib/fa/file-image-o';
import FaFilePdfO from 'react-icons/lib/fa/file-pdf-o';
import FaFileArchiveO from 'react-icons/lib/fa/file-archive-o';
import FaFileExcelO from 'react-icons/lib/fa/file-excel-o';
import FaFileWordO from 'react-icons/lib/fa/file-word-o';
import FaFilePowerpointO from 'react-icons/lib/fa/file-powerpoint-o';
import FaFileTextO from 'react-icons/lib/fa/file-text-o';
import FaFileMovieO from 'react-icons/lib/fa/file-movie-o';

import videoExt from './videoExtensions';

const imagesExt = ['png', 'svg', 'jpg', 'jpeg', 'bmp'];
const archiveExt = ['zipx', 'zip', 'rar', 'jpeg', 'dmg', 'gz'];
const excelExt = ['xls', 'xlt', 'xlm', 'xlsx', 'xlsm', 'xltx', 'xltm', 'xlsb', 'xla', 'xlam', 'csv'];
const wordExt = ['doc', 'dot', 'wbk', 'docx', 'docm', 'dotx', 'dotm', 'docb'];
const ppointExt = ['ppt', 'pot', 'pps', 'pptx', 'pptm', 'potx', 'potm', 'sldx'];
const textExt = ['txt', 'log'];

function iconType(fileName) {
  const props = { size: 25, height: 35, className: 'mr-2' };
  const fileExt = fileName.split('.').pop().toLowerCase();
  if (imagesExt.includes(fileExt)) {
    return <FaFileImageO {...props} />;
  }
  if (['pdf'].includes(fileExt)) {
    return <FaFilePdfO {...props} />;
  }
  if (archiveExt.includes(fileExt)) {
    return <FaFileArchiveO {...props} />;
  }
  if (excelExt.includes(fileExt)) {
    return <FaFileExcelO {...props} />;
  }
  if (wordExt.includes(fileExt)) {
    return <FaFileWordO {...props} />;
  }
  if (ppointExt.includes(fileExt)) {
    return <FaFilePowerpointO {...props} />;
  }
  if (textExt.includes(fileExt)) {
    return <FaFileTextO {...props} />;
  }
  if (videoExt.includes(fileExt)) {
    return <FaFileMovieO {...props} />;
  }
  return <FaFileO {...props} />;
}

const FileLine = ({ fileName }) => (
  <div className="row">
    <div className="col-12 text-truncate align-self-center">
      {iconType(fileName)}
      {fileName}
    </div>
  </div>
);

FileLine.propTypes = {
  fileName: PropTypes.string.isRequired,
};
FileLine.defaultProps = {};

export default FileLine;
